import { render, staticRenderFns } from "./billing-payment-form.vue?vue&type=template&id=6316d23d&scoped=true&lang=pug"
import script from "./billing-payment-form.vue?vue&type=script&lang=js"
export * from "./billing-payment-form.vue?vue&type=script&lang=js"
import style0 from "./billing-payment-form.vue?vue&type=style&index=0&id=6316d23d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6316d23d",
  null
  
)

export default component.exports